// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type FeaturedCategoriesStateModel = {
    data: {
        [key: string]: {
            list: CategoryModel[];
            isLoading: boolean;
        };
    };
};

const initialState: FeaturedCategoriesStateModel = {
    data: {},
};

const xFeaturedCategoriesData = createTypedReducerWithImmer(initialState, {
    "xFeaturedCategories/setLoading": (draft: Draft<FeaturedCategoriesStateModel>, action: { key?: string }) => {
        if (action.key) {
            draft.data[action.key] = {
                list: draft.data[action.key]?.list || [],
                isLoading: true,
            };
        }
    },
    "xFeaturedCategories/CompleteLoad": (
        draft: Draft<FeaturedCategoriesStateModel>,
        action: { featuredCategoriesData: CategoryModel[]; key?: string },
    ) => {
        if (action.key) {
            draft.data[action.key] = {
                list: action.featuredCategoriesData!,
                isLoading: false,
            };
        }
    },
    "xFeaturedCategories/FailedLoad": (draft: Draft<FeaturedCategoriesStateModel>, action: { key?: string }) => {
        if (action.key) {
            draft.data[action.key] = {
                list: [],
                isLoading: false,
            };
        }
    },
});

(reducers as any).xFeaturedCategoriesData = xFeaturedCategoriesData;

export type xFeaturedCategoriesData = {
    xFeaturedCategoriesData: FeaturedCategoriesStateModel;
} & ApplicationState;

type FeaturedCategoriesDataReducer = {
    featuredCategoriesData: typeof xFeaturedCategoriesData;
};

export type FeaturedCategoriesDataActions =
    | Parameters<FeaturedCategoriesDataReducer[keyof FeaturedCategoriesDataReducer]>[1]
    | AnyAction;
